import {
  AppShell,
  AppShellHeader,
  AppShellNavbar,
  Badge,
  Button,
  Card,
  createTheme,
  Fieldset,
  Input,
  type MantineBreakpoint,
  Menu,
  NavLink,
  Paper,
  Popover,
  SegmentedControl,
  Select,
  Skeleton,
  Table,
  Text,
} from '@mantine/core'

export const headerHeight = 60
export const mobileBreakpoint: MantineBreakpoint = 'md'

export const theme = createTheme({
  primaryColor: 'blue',
  primaryShade: {
    light: 8,
    dark: 7,
  },
  components: {
    AppShell: AppShell.extend({
      styles: {
        navbar: {},
      },
    }),
    AppShellHeader: AppShellHeader.extend({
      defaultProps: {
        withBorder: false,
      },
    }),
    AppShellNavbar: AppShellNavbar.extend({
      defaultProps: {
        withBorder: false,
        p: 'md',
        pt: 'sm',
        pb: 'sm',
      },
    }),
    NavLink: NavLink.extend({
      styles: {
        root: {
          borderRadius: 10,
        },
      },
    }),
    Paper: Paper.extend({
      defaultProps: {
        withBorder: false,
      },
    }),
    Card: Card.extend({
      styles: {
        root: {
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        },
      },
      defaultProps: {
        withBorder: true,
      },
    }),
    Text: Text.extend({
      defaultProps: {
        size: 'md',
      },
    }),
    Fieldset: Fieldset.extend({
      defaultProps: {
        bg: 'transparent',
      },
      styles: {
        root: {
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        },
      },
    }),
    Input: Input.extend({}),
    Select: Select.extend({}),
    Menu: Menu.extend({}),
    Popover: Popover.extend({}),
    Button: Button.extend({
      defaultProps: {
        variant: 'light',
        fullWidth: true,
      },
    }),
    SegmentedControl: SegmentedControl.extend({}),
    Badge: Badge.extend({
      defaultProps: {
        color: 'default',
      },
    }),
    Table: Table.extend({
      defaultProps: {
        highlightOnHover: true,
      },
    }),
    Skeleton: Skeleton.extend({
      defaultProps: {
        style: {
          opacity: 0.5,
          textAlign: 'center',
          justifyItems: 'center',
        },
      },
    }),
  },
})
